import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { EllipsisTooltip } from '@zenlayer/zen-design';
import { pickDomAttrs } from '@zenlayer/zen-design/esm/_util/utils';
import { listUrlParamsStringify } from '@zenlayer/zen-design/esm/hooks';
import t from '@zenlayer/zen-intl18';
const getBmcNetworkPricingModel = (networkType) => {
    if (!networkType)
        return undefined;
    return new Map([
        // 流量包
        [
            'flowPackageBandwidth',
            {
                name: t('ehXD9o7Z0Cyq'),
            },
        ],
        // 固定带宽
        [
            'limitedBandwidthUnmeteredTraffic',
            {
                name: t('vnH5dGv5Cfs9'),
            },
        ],
        // BAG95
        [
            'zoneBandwidthGroupP95',
            {
                name: t('9BvyQkLOyMbW'),
            },
        ],
        // 合并95
        [
            'aggregateBandwidthP95',
            {
                name: t('9BvyQkLOyMbW'),
            },
        ],
        // 单机95 (废弃)
        [
            'burstBandwidth',
            {
                name: t('C8aHATMTujF8'),
            },
        ],
        // 大区带宽组
        [
            'bandwidthCluster',
            {
                name: t('z9xogNxU46Et'),
            },
        ],
    ]).get(networkType);
};
export var VmInternetChargeType;
(function (VmInternetChargeType) {
    VmInternetChargeType["BANDWIDTH"] = "BandwidthByInstance";
    VmInternetChargeType["Burstable95"] = "BandwidthZone95";
    VmInternetChargeType["PACKAGEBANDWIDTH"] = "PackageBandwidth";
    VmInternetChargeType["BandwidthCluster"] = "BandwidthCluster";
    VmInternetChargeType["ByInstanceBandwidth95"] = "ByInstanceBandwidth95";
})(VmInternetChargeType || (VmInternetChargeType = {}));
const getVmNetworkPricingModel = (internetChargeType) => {
    if (!internetChargeType)
        return undefined;
    return new Map([
        [
            'BandwidthByInstance',
            {
                name: t('n4RynVUrcKFL'),
            },
        ],
        [
            'BandwidthZone95',
            {
                name: t('m5S6SWeX9xpy'),
            },
        ],
        [
            'PackageBandwidth',
            {
                name: t('SwWlhegFeIYX'),
            },
        ],
        [
            'BandwidthCluster',
            {
                name: t('QUD9tHufbXtR'),
            },
        ],
        [
            'ByInstanceBandwidth95',
            {
                name: t('ug7uOz6IqfA6'),
            },
        ],
    ]).get(internetChargeType);
};
export var RiptInternetType;
(function (RiptInternetType) {
    RiptInternetType["ByBandwidth"] = "ByBandwidth";
    RiptInternetType["ByInstanceBandwidth95"] = "ByInstanceBandwidth95";
})(RiptInternetType || (RiptInternetType = {}));
const getRiptNetworkPricingModel = (internetType) => {
    if (!internetType)
        return undefined;
    return new Map([
        [
            'ByBandwidth',
            {
                name: t('kkfP4dGE5YdE'),
            },
        ],
        [
            'ByInstanceBandwidth95',
            {
                name: t('2Fl4GFAStBuw'),
            },
        ],
    ]).get(internetType);
};
export const getNetworkPricingModel = ({ data, checkAuth, dataAttrs, }) => {
    const getBandwidthCluster = () => {
        if ((data?.internetChargeType === VmInternetChargeType.BandwidthCluster ||
            data.networkType === 'bandwidthCluster') &&
            data?.bandwidthCluster) {
            return checkAuth('ipt:cluster:list') ? (_jsx("a", { ...pickDomAttrs(dataAttrs?.clusterLink).data, href: `/traffic/bandwidth-cluster/list?${listUrlParamsStringify({
                    clusterId: data?.bandwidthCluster?.clusterId,
                })}`, children: _jsx(EllipsisTooltip, { children: data?.bandwidthCluster?.name }) })) : (_jsx(EllipsisTooltip, { children: data?.bandwidthCluster?.name }));
        }
    };
    if (data.internetChargeType) {
        const info = getVmNetworkPricingModel(data.internetChargeType);
        return info ? (_jsxs(_Fragment, { children: [_jsx("div", { children: info?.name || '-' }), getBandwidthCluster()] })) : null;
    }
    if (data.networkType) {
        const info = getBmcNetworkPricingModel(data.networkType);
        return info ? (_jsxs(_Fragment, { children: [_jsx("div", { children: info?.name || '-' }), getBandwidthCluster()] })) : null;
    }
    if (data.internetType) {
        const info = getRiptNetworkPricingModel(data.internetType);
        return info ? _jsx("div", { children: info?.name || '-' }) : null;
    }
};
/**
 *
 * ### Minimal usage example
 * ```jsx
 *  <NetworkPricingModel
      data={detailData}
      checkAuth={checkAuth}
    />
 * ```
 */
export const NetworkPricingModel = (props) => {
    return getNetworkPricingModel(props);
};
